import { render } from "./Resource.vue?vue&type=template&id=a12f53a0&scoped=true"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"

import "./Resource.vue?vue&type=style&index=0&id=a12f53a0&lang=css"
import "./Resource.vue?vue&type=style&index=1&id=a12f53a0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12f53a0"]])

export default __exports__